let id = 1;
const randomId = () => {
	id++;
	return id;
};

export const navbarItems = [
	{
		id: randomId(),
		link: "/",
		icon: "fas fa-home",
		title: "لوحة التحكم",
		children: [],
	},
	{
		id: randomId(),
		link: "/moderators/index",
		icon: "fas fa-users-cog",
		title: "المشرفين",
		children: [
			{
				id: randomId(),
				title: "جميع المشرفين",
				link: "/moderators/index",
			},
			{
				id: randomId(),
				title: "اضافة مشرف جديد",
				link: "/moderators/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/category/index",
		icon: "fas fa-object-group",
		title: "التصنيفات",
		children: [
			{
				id: randomId(),
				title: "جميع التصنيفات",
				link: "/category/index",
			},
			{
				id: randomId(),
				title: "اضافة تصنيف جديدة",
				link: "/category/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/products/index",
		icon: "fas fa-solid fa-building",
		title: "المنتجات",
		children: [
			{
				id: randomId(),
				title: "جميع المنتجات",
				link: "/products/index",
			},
			{
				id: randomId(),
				title: "اضافة منتج جديدة",
				link: "/products/create",
			},
			// {
			// 	id: randomId(),
			// 	title: "جميع الانواع",
			// 	link: "/type/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "اضافة نوع جديدة",
			// 	link: "/type/create",
			// },
		],
	},
	{
		id: randomId(),
		link: "/latestProjects/index",
		icon: "fas fa-solid fa-building",
		title: "احدث المشاريع",
		children: [
			{
				id: randomId(),
				title: "جميع المشاريع",
				link: "/latestProjects/index",
			},
			{
				id: randomId(),
				title: "اضافة مشروع جديدة",
				link: "/latestProjects/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/service/index",
		icon: "fas fa-solid fa-building",
		title: "الخدمات",
		children: [
			{
				id: randomId(),
				title: "جميع الخدمات",
				link: "/service/index",
			},
			{
				id: randomId(),
				title: "اضافة خدمة جديدة",
				link: "/service/create",
			},
			// {
			// 	id: randomId(),
			// 	title: "جميع الانواع",
			// 	link: "/type/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "اضافة نوع جديدة",
			// 	link: "/type/create",
			// },
		],
	},

	{
		id: randomId(),
		link: "/brands/index",
		icon: "fas fa-cube",
		title: "الماركات",
		children: [
			{
				id: randomId(),
				title: "جميع الماركات",
				link: "/brands/index",
			},
			{
				id: randomId(),
				title: "اضافة ماركة جديدة",
				link: "/brands/create",
			},
		],
	},
	// {
	// 	id: randomId(),
	// 	link: "/comments/index",
	// 	icon: "fas fa-comments",
	// 	title: "اراء العملاء",
	// 	children: [
	// 		{
	// 			id: randomId(),
	// 			title: "جميع الاراء",
	// 			link: "/comments/index",
	// 		},
	// 		{
	// 			id: randomId(),
	// 			title: "اضافة رائ جديدة",
	// 			link: "/comments/create",
	// 		},
	// 	],
	// },
	{
		id: randomId(),
		link: "/orders/index",
		icon: "fas fa-envelope",
		title: "الطلبات",
		children: [],
	},
	{
		id: randomId(),
		link: "/social",
		title: "وسائل التواصل",
		icon: "fas fa-id-card",
		children: [
			// {
			// 	id: randomId(),
			// 	title: " انواع التواصل",
			// 	link: "/social/socialType/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "اضافة نوع تواصل",
			// 	link: "/social/socialType/create",
			// },
			{
				id: randomId(),
				title: " روابط التواصل",
				link: "/social/links/index",
			},
			{
				id: randomId(),
				title: "اضافة رابط تواصل",
				link: "/social/links/create",
			},
		],
	},
	{
		id: randomId(),
		link: "/siteinfo",
		icon: "far fa-address-card",
		title: " بيانات الموقع ",
		children: [
			{
				id: randomId(),
				title: "لافتات الترحيب",
				link: "/siteinfo/heroSection/index",
			},
			{
				id: randomId(),
				title: "عن راسيات",
				link: "/siteinfo/aboutUs/index",
			},
			// {
			// 	id: randomId(),
			// 	title: "لماذا تختار راسيات",
			// 	link: "/siteinfo/whyUs/index",
			// },

			// {
			// 	id: randomId(),
			// 	title: "البيانات الاضافيه",
			// 	link: "/aboutPage/sideinfo/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "المميزات",
			// 	link: "/aboutPage/advantages/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "الاحصائيات",
			// 	link: "/aboutPage/statistics/index",
			// },
			// {
			// 	id: randomId(),
			// 	title: "الأسئله الشائعه",
			// 	link: "/aboutPage/questions/index",
			// },
		],
	},
];
